import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ShipmentsList from './ShipmentsList'
import ShipmentDetail from './ShipmentDetail'
import ShipmentCreate from './ShipmentCreate'
import RequestAccess from './RequestAccess'
import useUserStore from '@src/state/user'
import { useAuth } from '@src/hooks/useAuth'

const ShipmentsPage: React.FC = () => {
  const { customer } = useAuth()

  // Check if shipments module is enabled
  const isShipmentsEnabled = customer?.shipmentDocuments?.enabled === true

  if (!isShipmentsEnabled) {
    return <RequestAccess />
  }

  return (
    <Routes>
      <Route path="/" element={<ShipmentsList />} />
      <Route path="/new" element={<ShipmentCreate />} />
      <Route path="/:id" element={<ShipmentDetail />} />
    </Routes>
  )
}

export default ShipmentsPage
